import React from "react";
import { Row, Col } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import ButtonSubmit from "../buttons/ButtonSubmit";
import ButtonProcessing from "../buttons/ButtonProcessing";

function isValidDate(d) {
  let date = new Date(d);
  return date instanceof Date && !isNaN(date);
}

const DateRangeForm = ({ onSubmit, toDate, fromDate, formSubmitting }) => {
  return (
    <>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form, submitting, values }) => (
          <form onSubmit={handleSubmit}>
            <Row>
              <Col>
                <Field
                  name='fromDate'
                  component='input'
                  type='date'
                  className='form-control m-2'
                  initialValue={fromDate}
                  cypressid='fromDate'
                />
              </Col>
              {!isValidDate(values.fromDate) ? <span className='error' role="alert">Not a valid date</span> : ""}
              <Col>
                <Field
                  name='toDate'
                  component='input'
                  type='date'
                  className='form-control m-2'
                  initialValue={toDate}
                  cypressid='toDate'
                />
                {!isValidDate(values.toDate) ? <span className='error' role="alert">Not a valid date</span> : ""}
              </Col>
              <Col>
                {formSubmitting ? (
                  <ButtonProcessing id='ddw-primary' disabled cypressid='dateRangeFormSubmitting' />
                ) : (
                  <ButtonSubmit id='ddw-primary' cypressid='dateRangeFormSubmit' />
                )}
              </Col>
            </Row>
          </form>
        )}
      />
    </>
  );
};

export default DateRangeForm;
